module.exports = __webpack_public_path__ + "img/payment-icon-01.c9ab8bea.png";